import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'

export default class extends Controller {
  static values  = { title: String, a: Number, b: Number, c: Number }

  connect() {
    this.initChart()
  }

  initChart() {
    let chart = Highcharts.chart(this.element, {
      title: { text: this.titleValue, align: 'center', verticalAlign: 'middle', x: 0, y: 80 },
      plotOptions: {
        pie: {
          dataLabels: { enabled: true, distance: -5,  style: { fontSize: '15px' } }
        }
      },
      chart: {
        spacingLeft: 0,
        spacingRight: 0,
        backgroundColor: 'transparent'
      },
      tooltip: { pointFormat: '<strong>{point.percentage:.1f}%</strong>' },
      navigation: { buttonOptions: { enabled: false } },
      series: [{
        type: 'pie',
        innerSize: '50%',
        data: [['Ouvert', this.aValue], ['Non ouverts', this.bValue], ['Clicks', this.cValue]]
      }]
    })
    chart.setSize(400,400)
  }
}
